export default class Carousel {
  constructor() {
    this.selector = '.js-carousel';
    this.currentSlide = 0;
  }

  render() {
    const self = this;

    if (!this.selector) {
      return;
    }

    import(/* webpackChunkName: "js/slick" */ 'slick-carousel').then(() => {
      $(() => {
        $(self.selector).each((key, item) => {
          const carousel = $(item);

          carousel.on('init', (event, slick) => {
            self.currentSlide = slick.currentSlide;
            self.constructor.animateSlide($(item), 1);
          });

          carousel.slick({
            arrows: true,
            swipe: false,
            autoplay: true,
            pauseOnHover: false,
            speed: 1000,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            prevArrow: `<button type="button" class="svg-container slick-arrow slick-prev"><svg id="Warstwa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 13"><path fill="#010101" d="M.9 6.5l6-5.9C7 .5 7 .4 7 .4c0-.1 0-.2-.1-.3-.1-.1-.4-.1-.5 0L.1 6.2c-.1.2-.1.4 0 .6l6.3 6.1c.1.1.4.1.5 0 .1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l-6-5.8z"/></svg></button>`,
            nextArrow: `<button type="button" class="svg-container slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 13"><path d="M.1 12.3c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3.1.1.4.1.5 0l6.3-6.1c.1-.2.1-.4 0-.6L.6.1C.5 0 .2 0 .1.1S0 .3 0 .4c0 0 0 .1.1.2l6 5.9-6 5.8z" fill="#010101"/></svg></button>`,
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  arrows: false,
                  swipe: true,
                  dots: true,
                },
              },
            ],
          });

          carousel.on('afterChange', (event, slick, currentSlide) => {
            if (self.currentSlide !== currentSlide) {
              self.currentSlide = currentSlide;
              self.constructor.animateSlide($(item), currentSlide + 1);
            }
          });
        });
      });
    });
  }

  static animateSlide(carousel, slideNumber) {
    const slide = carousel.find('.slick-slide').eq(slideNumber);

    carousel.find('.slick-slide').find('.animated').each((key, item) => {
      const vm = $(item);
      vm.removeClass('fadeInUp fadeInRight finish');
    });

    slide.find('.animated').each((key, item) => {
      const vm = $(item);
      const animation = vm.data('animate-in');
      vm.addClass(`${animation} finish`);
    });
  }
}
